import * as yup from 'yup';
import i18next from 'i18next';

// COMMONS
import { INPUT_TYPES } from '@commons/constants/inputType';
import { INPUT_WIDTH } from '@commons/utils/styledLibraryComponents';

const INVENTORY_LIST_TEMPLATE_INPUTS = {
  NAME: 'name',
};

export const FIELDS_TO_CHECK = ['name'];

export const INVENTORY_LIST_TEMPLATE_INFOS_INPUTS = () => [
  {
    type: INPUT_TYPES.TEXT,
    name: INVENTORY_LIST_TEMPLATE_INPUTS.NAME,
    width: INPUT_WIDTH.LARGE,
    isRequired: true,
    label: `* ${i18next.t('GENERAL.NAME')}`,
    rule: yup.string().required(
      i18next.t('ADMIN.SUPPLIER_PRODUCTS.DETAIL_FORM_FIELD_REQUIRED_ERROR', {
        field: i18next.t('GENERAL.NAME'),
      }),
    ),
  },
];

export const INVENTORY_LIST_TEMPLATE_FORM_INPUTS = () => [
  ...INVENTORY_LIST_TEMPLATE_INFOS_INPUTS(),
];
